import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import { LfnUpstreamEquipmentOverwriteComponent } from "../../components/lfn-flow/lfn-upstream-equipment-overwrite/lfn-upstream-equipment-overwrite.component";
import { TableComponent } from "../../components/common/table/table.component";
import { TitleTextPipe } from "../../custom.pipe";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ApiService } from "../../api.service";
import { JlStructureComponent } from "../../components/common/jl-structure/jl-structure.component";
import { MapHDComponent } from "../map-hd/map-hd.component";
import { SmpConnectivityHDComponent } from "../smp-connectivity-hd/smp-connectivity-hd.component";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MessageComponent } from "../../components/common/message/message.component";
import { UploadFileComponent } from "../../components/common/upload-file/upload-file.component";

@Component({
    selector: "app-select-bjl-hd",
    standalone: true,
    imports: [
        TableComponent,
        CommonModule, UploadFileComponent,
        NgxSpinnerModule, MessageComponent,
        TitleTextPipe, MapHDComponent, SmpConnectivityHDComponent,
        LfnUpstreamEquipmentOverwriteComponent, JlStructureComponent
    ],
    templateUrl: "./select-bjl-hd.component.html",
    styleUrls: ["./select-bjl-hd.component.scss"]
})

export class SelectBjlHDComponent implements OnInit {
  
  @Input() inputData : any;
  tableData: any;
  myForm!: FormGroup;

  displayedColumns: string[] = [];
  dataSource!: MatTableDataSource<any>;
  showBJLTable: boolean = true;
  isLoading: boolean = false;
  showMessage: boolean = false;
  MessageToShow: any;
  select_jl_screen: boolean = false;
  select_smp_screen: boolean = false;
  show_smp_table: boolean = false;
  select_table = true;
  upstream_screen = false;
  show_distance = false;
  @ViewChild(TableComponent)
  tableChildComponent!: TableComponent;
  @ViewChild(MapHDComponent)
  mapChildComponent!: MapHDComponent;
  smp_connectivity_flag: boolean = false;
  select_bjl_structure_payload: any;
  pit_value : string = "";
  pit_size_value : string = "";
  show_status:boolean = false;
  pit_validation:any;
  update_pit:boolean = false;
  trench_creation:boolean = false;
  no_of_pits:string = '';
  a_pit:string = '';
  z_pit:string = '';
  user_message:string='';
  final_screen:boolean = false;
  showADRCard:boolean = false;
  url: string = '';
  filename: string = '';
  msg: string = ''; 
  selectedRow: any;
  myAdrForm!: FormGroup;
  file: string | null = null;
  map_div: boolean = true;
  select_bjl: boolean = false;
  selectedSPL :string = '';
  fjl_id: string ='';
  selectedFJLSPL: string ='';
  
  constructor(private toastr: ToastrService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router,
  private fb: FormBuilder) { 
    this.myForm = this.fb.group({
          a_pit: ['', Validators.required],
          z_pit: ['', Validators.required],
          no_of_pits: ['', Validators.required]
    });
    this.myAdrForm = this.fb.group({
        ADRpath: [''],
      });
  }

  ngOnInit() {

  }


  fileUploaded(event: string) {
    this.file = event;
  }

 
  receiveTableEventUpstream(data:any) {
    this.inputData['selected_upstream_equipment'] = data;
    this.isLoading = true;
    this.spinner.show();
    this.apiService.selectUpstreamStructureHD(this.inputData).subscribe({
      next: (response) => {

            if (response.message === 'select bjl structure n2p') {
              this.showBJLTable = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.select_smp_screen = true;
              this.update_pit = true;
              this.show_smp_table = false;
              this.tableData = response;
              this.select_bjl_structure_payload = response;
            }            
            else {              
              if ('file_name' in response) {
                this.showBJLTable = false;
                this.upstream_screen = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
            // window.alert(response.messgae);
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
          },
    });
 }
  receiveTableEvent(data:any) {
    this.inputData['selected_bjl'] = data;
    this.isLoading = true;
    this.spinner.show()  
    if(this.inputData.request_type == "FMB_request"){
        this.apiService.checkBjlCapacityHD(this.inputData).subscribe({
        next: (response) => {
              if (response.message == 'select bjl n2p') {
                this.showBJLTable = true;
                this.upstream_screen = false;
                this.inputData = response;
                this.tableData = response;
                if(this.inputData.user_message != ''){
                  this.user_message = this.inputData.user_message;
                }
                this.tableChildComponent.initializeFunction(this.inputData);
              }
              else if(response.message == 'n2p process completed'){
                  this.showBJLTable = false;
                  this.final_screen = true;
                  this.tableData = response;
                  this.inputData = response;
              }
                else if (response.message == 'select upstream equipment n2p') {
                this.showBJLTable = false;
                this.upstream_screen = true;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
              }
              else {              
                if ('file_name' in response) {
                  this.showBJLTable = false;
                  this.showMessage = true;
                  this.MessageToShow = response;
                } else {
                  this.toastr.error(response.message, 'Error Message');
                  console.log('error');
                }
              }

              this.isLoading = false;
              this.spinner.hide();
              // window.alert(response.messgae);
        }
        ,
        error: (error) => {
              this.isLoading = false;
              this.spinner.hide();
              this.toastr.error(
                `The API returned Unsuccessfull response : ${error}`,
                'Error Message'
              );
            },
      });
    }
    else{
      this.apiService.selectBjlHD(this.inputData).subscribe({
        next: (response) => {
              if (response.message === 'select smp structure') {
                this.showBJLTable = false;
                this.upstream_screen = false;
                this.inputData = response;
                this.select_smp_screen = true;
                this.show_smp_table = true;
                this.tableData = response;
              }
              else if (response.message == 'select bjl n2p') {
                this.showBJLTable = true;
                this.upstream_screen = false;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
              }
                else if (response.message == 'select upstream equipment n2p') {
                this.showBJLTable = false;
                this.upstream_screen = true;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
              }
              else {              
                if ('file_name' in response) {
                  this.showBJLTable = false;
                  this.showMessage = true;
                  this.MessageToShow = response;
                } else {
                  this.toastr.error(response.message, 'Error Message');
                  console.log('error');
                }
              }

              this.isLoading = false;
              this.spinner.hide();
              // window.alert(response.messgae);
        },
        
        error: (error) => {
              this.isLoading = false;
              this.spinner.hide();
              this.toastr.error(
                `The API returned Unsuccessfull response : ${error}`,
                'Error Message'
              );
              //window.alert(`The API returned Unsuccessfull response : ${error}`);
            },
      });
    }
  }
  callBack() {
    this.showBJLTable = false;
    this.upstream_screen = false;
    this.select_smp_screen = true;
    this.show_smp_table = false;
    this.select_bjl_structure_payload["message"] = "select bjl structure n2p";
    this.mapChildComponent.receiveTableEvent(this.select_bjl_structure_payload);
  }
  OnSelectProceedMap(data: any) {
    //this.inputData['selected_smp_structure'] = data;    
    this.isLoading = true;
    this.spinner.show() 
    this.trench_creation = false; 
    this.pit_value = '';
    if(this.inputData.request_type == "FMB_request"){
        this.apiService.newhdBjl(this.inputData).subscribe({
        next: (response) => {
              if (response.message == 'select bjl n2p') {
                this.showBJLTable = true;
                this.upstream_screen = false;
                this.select_smp_screen = false;
                this.inputData = response;
                this.tableData = response;
                if(this.inputData.user_message != ''){
                  this.user_message = this.inputData.user_message;
                }
                //this.tableChildComponent.initializeFunction(this.inputData);
              }
               
              else if(response.message == 'n2p process completed'){
                  this.showBJLTable = false;
                  this.final_screen = true;
                  this.tableData = response;
                  this.inputData = response;
              }
              else {              
                if ('file_name' in response) {
                  this.showBJLTable = false;
                  this.showMessage = true;
                  this.MessageToShow = response;
                } else {
                  this.toastr.error(response.message, 'Error Message');
                  console.log('error');
                }
              }

              this.isLoading = false;
              this.spinner.hide();
              // window.alert(response.messgae);
        }
        ,
        error: (error) => {
              this.isLoading = false;
              this.spinner.hide();
              this.toastr.error(
                `The API returned Unsuccessfull response : ${error}`,
                'Error Message'
              );
            },
      });
    }
    else{
    this.apiService.selectSmpStructureHD(this.inputData,this.inputData.message).subscribe({
      next: (response) => {   
    
            if (response.message === 'select smp structure') {
              this.showBJLTable = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = true;
              //this.tableChildComponent.initializeFunction(this.inputData);
              this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select bjl structure n2p') {
              this.showBJLTable = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = false;
              this.update_pit = false;
              //this.select_bjl_structure_payload = response;
              //this.tableChildComponent.initializeFunction(this.inputData);
              this.mapChildComponent.receiveTableEvent(this.inputData);
            }
            else if (response.message == 'select new smp') {
              this.smp_connectivity_flag = true;
              this.select_jl_screen = false;
              this.select_smp_screen = false;
              this.upstream_screen = false;
              this.showBJLTable = false;
              this.tableData = response;
              this.inputData = response;
              this.update_pit = false;
              }
            else if(response.message == 'No path found for BJL')
            {
              this.trench_creation = true;
              this.update_pit = false;
            }
            else {              
              if ('file_name' in response) {
                this.showBJLTable = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            }

            this.isLoading = false;
            this.spinner.hide();
      }
      ,
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
  }
  }

  receiveTableEventStructure(data: any) {
    this.mapChildComponent.receiveTableEvent(data,'bjl_smp')
  }

  callBJL() {
    this.isLoading = true;
    this.spinner.show();
    this.apiService.bjlpathoverwriteHD(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'select upstream equipment n2p') {
              this.smp_connectivity_flag = false;
              this.select_jl_screen = false;
              this.select_smp_screen = false;
              this.showBJLTable = false;
              this.upstream_screen = true;
              this.inputData = response;
              this.tableData = response;
              this.tableChildComponent.initializeFunction(this.inputData);
          } else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }

 inputOnChange(event: Event) {
  const input = event.target as HTMLInputElement;

  if (input.value.includes('FJL')) {
    this.fjl_id = input.value;
  } else {
    this.pit_value = input.value;
  }

  console.log('Value:', input.value);
}

  pitSizeOnChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.pit_size_value = input.value
    console.log('Value:', input.value);
  }

  checkDistance(){
    this.isLoading = true;
    this.show_distance = false;
    this.spinner.show();
    this.inputData['selected_bjl_val'] = this.inputData.selected_bjl.bjl_id;
    this.inputData['selected_pit_val'] = this.pit_value;
    this.apiService.pitBjlDistancehd(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'select smp structure') {
              this.showBJLTable = false;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.select_smp_screen = true;
              this.show_smp_table = true;
              
              this.show_status = true;
              this.pit_validation = this.inputData.pit_validation;
              if(this.pit_validation.pit_location == undefined || this.pit_validation.pit_location == null ) {
                  this.show_distance = true;
                  //this.tableChildComponent.initializeFunction(this.inputData);
                  this.mapChildComponent.receiveTableEvent(this.inputData);
              }
              //this.pit_validation.pit_status = false;
              if(this.pit_validation.pit_status == false){
                this.update_pit = true;
              }
              else{
                this.update_pit = false;
              }
              this.mapChildComponent.receiveTableEvent(this.inputData);
          }
          
          else if (response.message == 'select bjl n2p') {
              this.showBJLTable = true;
              this.upstream_screen = false;
              this.inputData = response;
              this.tableData = response;
              this.tableChildComponent.initializeFunction(this.inputData);
            }
          else if (response.message == 'select upstream equipment n2p') {
              this.showBJLTable = false;
              this.show_smp_table = false;
              this.select_smp_screen = false;
              this.upstream_screen = true;
              this.inputData = response;
              this.tableData = response;
              //this.tableChildComponent.initializeFunction(this.inputData);
            }
            else if(response.message == "Pit Fitness Failed"){
              this.update_pit = true;
              this.show_status = true;
              this.inputData = response;
              this.pit_validation = this.inputData.pit_validation;
              if(this.pit_validation.pit_distance == 'no path' || this.pit_validation.pit_distance == 'The distance is more than 500.'){
                this.trench_creation = true;
                this.update_pit = false;
              }
              this.toastr.error(response.message, 'Error Message');
          }
          else {              
              if ('file_name' in response) {
                this.showBJLTable = false;
                this.showMessage = true;
                this.MessageToShow = response;
              } else {
                this.toastr.error(response.message, 'Error Message');
                console.log('error');
              }
            } 

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }
  
  pitSizeChange(){
    this.isLoading = true;
    this.spinner.show();
    this.inputData['updated_pit_size'] = this.pit_size_value;
    this.inputData['selected_pit_val'] = this.pit_value;
    this.apiService.pitSizeUpdatehd(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'pit size updated successfully') {              
              this.update_pit = false;
              this.inputData = response;
              this.tableData = response;
              this.mapChildComponent.receiveTableEventPit(this.inputData);
              this.inputData['selected_pit_val'] = '';
              this.inputData['updated_pit_size'] = '';
              this.toastr.success(
              response.message,
              'success Message'
            );
              
          } else if(response.message == "Pit Fitness Failed"){
            this.update_pit = true;
          }else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }

  updateVal(event: Event,field_type:string){
    const input = event.target as HTMLInputElement;
    if(field_type == 'a_pit'){
        this.a_pit = input.value
    }
    else if(field_type == 'z_pit'){
      this.z_pit = input.value
    }
    else if(field_type == 'no_of_pits'){
      this.no_of_pits = input.value
    }
  }
  onSubmit(){
    this.isLoading = true;
    this.spinner.show();
    this.inputData['a_pit'] = this.a_pit;
    this.inputData['z_pit'] = this.z_pit;
    this.inputData['no_of_pits'] = this.no_of_pits;
    this.apiService.createTrenchN2P(this.inputData).subscribe({
        next: (response) => {
          if (response.message == 'New Pit and Trenches Created') {              
              this.update_pit = true;
              this.trench_creation = false;
              this.inputData = response;
              this.tableData = response;
              this.mapChildComponent.receiveTableEventPit(this.inputData);
              this.toastr.success(
                response.message,
                'success Message'
              );
              
          } else if(response.message == "Process Failed"){
            this.update_pit = false;
            this.trench_creation = true;
            this.toastr.success(
                response.message,
                'Error Message'
              );
          }else {
            //this.showTable = false;
              this.toastr.error(
              `The API returned Unsuccessfull response`,
              'Error Message'
            );
          }

          this.isLoading = false;
          this.spinner.hide();
        },
        error: (error) => {
          this.isLoading = false;
          this.spinner.hide();
          this.toastr.error(
            `The API returned Unsuccessfull response : ${error}`,
            'Error Message'
          );
        },
      });
  }

  receiveTableEventFinalCall() {
    this.isLoading = true;
      this.spinner.show()  
      this.apiService.generateHDOutput(this.inputData).subscribe({
      next: (response) => {
                if (response.message == 'Pre-signed url has been generated') {
                  this.showMessage = true; 
                  // this.url = response.url;
                  // this.filename = response.file_name;
                  // this.msg = response.message;
                  this.MessageToShow = JSON.stringify(response);
                }
                else if (response.message == 'upload adr') {
                  this.showADRCard = true;
                  this.select_smp_screen = false;
                  this.upstream_screen = false;
                  this.final_screen = false;
                  this.final_screen = false;
                  this.inputData = response;
                }
                else {              
                  if ('file_name' in response) {
                    this.final_screen = false;
                    this.upstream_screen = false;
                    this.showMessage = true;
                    this.MessageToShow = response;
                  } else {
                    this.toastr.error(response.message, 'Error Message');
                    console.log('error');
                  }
                }

            this.isLoading = false;
            this.spinner.hide();
      },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
          },
    });
  }

table_function_called() {
    this.isLoading = true;
    this.spinner.show();
    if (this.selectedRow && this.selectedRow.length > 0) {
      let new_route_list = [];
      for (let ele of this.selectedRow) {
        new_route_list.push(ele['Paths']);
      }
      this.inputData['new_route_list'] = new_route_list;
    }
    this.inputData['adr_path'] = this.myAdrForm.value.ADRpath;
    this.inputData['adr_file_name'] = this.file;

    this.inputData['available_paths'] = this.inputData['available_paths'];
    this.apiService.onadrcallHD(this.inputData).subscribe({
      next: (response) => {
        this.showADRCard = false;

        if (response.message.indexOf(
            "Tool generated path doesn't match with ADR"
          ) != -1
        ) {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        } else if (response.message == 'Pre-signed url has been generated') {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        else if(response.message == 'select bjl n2p'){
            this.showADRCard = false; 
            this.inputData =  response;  
            //this.tableChildComponent.initializeFunction(this.inputData);
        } 
        else {
          this.url = response.url;
          this.filename = response.file_name;
          this.msg = response.message;
          this.showMessage = true;
          this.MessageToShow = JSON.stringify(response);
        }
        this.isLoading = false;
        this.spinner.hide();
        // window.alert(response.messgae);
      },
      error: (error) => {
        this.isLoading = false;
        this.spinner.hide();
        this.toastr.error(
          `The API returned Unsuccessfull response : ${error}`,
          'Error Message'
        );
        //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
    });
  }
  addSPL() {
  this.inputData['spl_details'] = this.selectedSPL;
  this.isLoading = true;
  this.spinner.show();
  this.apiService.newSPLHD(this.inputData).subscribe({
    next: (response) => {
      if (response.message === 'select bjl n2p') {
        this.showBJLTable = true;
        this.upstream_screen = false;
        this.inputData = response;
        this.tableData = response;
        if (this.inputData.user_message !== '') {
          this.user_message = this.inputData.user_message;
        }
        this.tableChildComponent.initializeFunction(this.inputData);
        
        // window.alert(response.messgae);
      }
       else {
            this.toastr.error(
                response.message,
              'Error Message'
            );
          }
      this.isLoading = false;
      this.spinner.hide();
    },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
  });
}

  fjladdSPL() {
  this.inputData['spl_type'] = this.selectedFJLSPL;
  this.inputData['fjl_id'] = this.fjl_id
  this.isLoading = true;
  this.spinner.show();
  this.apiService.newFJLSPLHD(this.inputData).subscribe({
    next: (response) => {
      if (response.message == 'select upstream equipment n2p') {
                this.showBJLTable = false;
                this.upstream_screen = true;
                this.inputData = response;
                this.tableData = response;
                this.tableChildComponent.initializeFunction(this.inputData);
              }

      else {
            this.toastr.error(
                response.message,
              'Error Message'
            );
          }
      this.isLoading = false;
      this.spinner.hide();  
    },
      error: (error) => {
            this.isLoading = false;
            this.spinner.hide();
            this.toastr.error(
              `The API returned Unsuccessfull response : ${error}`,
              'Error Message'
            );
            //window.alert(`The API returned Unsuccessfull response : ${error}`);
      },
  });
}


onSPLChange(event: Event) {
  const select = event.target as HTMLSelectElement;
  this.selectedSPL = select.value;
  // Also store it in inputData for convenience
  this.inputData['spl_details'] = this.selectedSPL;
}
onfjlSPLChange(event: Event) {
  const select = event.target as HTMLSelectElement;
  this.selectedFJLSPL = select.value;
  // Also store it in inputData for convenience
  this.inputData['spl_type'] = this.selectedFJLSPL;
}
}
